module.exports = __webpack_public_path__ + "media/images/banners/5-7b35050d3ecd697fcfcbb526b2fa8504.png";